<template>
  <div>
    <div class="container-title my-5">
      {{ $t('views.login.loginAgain') }}
    </div>
    <div class="container-form">
      <n-form
        ref="formRef"
        :model="loginFrom"
        :rules="loginFormRules"
        label-placement="left"
        label-width="auto"
        require-mark-placement="right-hanging"
        :style="{
          maxWidth: '640px',
        }"
      >
        <n-form-item path="username">
          <n-input
            v-model:value="loginFrom.username"
            :placeholder="$t('views.login.form.username.placement')"
          />
        </n-form-item>
        <n-form-item path="password">
          <n-input
            v-model:value="loginFrom.password"
            type="password"
            show-password-on="click"
            :placeholder="$t('views.login.form.password.placement')"
          />
        </n-form-item>
        <n-form-item path="captcha">
          <n-input
            v-model:value="loginFrom.captcha"
            show-password-on="click"
            :placeholder="$t('views.login.form.captcha.placement')"
          />
          <img
            style="height: 34px; border: 1px solid #ccc; margin-left: 10px"
            @click="captchaPic"
            :src="loginFrom.url"
          />
          <!-- <span
            class="ml-2"
            style="width: 4.5rem; cursor: pointer; color: rgb(51, 54, 57)"
            @click="captchaPic"
            >Change</span
          > -->
          <img
            class="ml-2"
            style="width: 1.2rem; cursor: pointer"
            @click="captchaPic"
            src="@/assets/icons/change.png"
            alt=""
          />
        </n-form-item>
        <n-form-item style="display: none">
          <n-form-item>
            <n-checkbox v-model:checked="loginFrom.rememberMe">
              {{ $t('views.login.remeber') }}
            </n-checkbox>
          </n-form-item>
        </n-form-item>
        <n-form-item class="mt-5">
          <at-button color="#407ABB" block @click="loginHandler" :loading="loading">
            {{ $t('views.login.form.button.text') }}
          </at-button>
        </n-form-item>
      </n-form>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import { onMounted, reactive, ref, unref } from 'vue';
  import { loginFormRules } from '@/views/login/login.data';
  import { LoginFrom } from '@/views/login/login.type';
  import { useUserStore } from '@/store/modules/user';
  import { ResultCodeEnum } from '@/enums/httpEnum';
  import { loginSuccess } from '@/views/login/helper';
  import { getCaptchaPicApi, getPicApi, postPicApi } from '@/api/captcha';
  import { TABS_ROUTES, PASSWORD_STATUS } from '@/store/mutation-types';
  import { storage } from '@/utils/Storage';
  import { getAppEnvConfig } from '@/utils/env';
  import { useDialog } from 'naive-ui';
  const { VITE_GLOB_BASE_URL, VITE_GLOB_API_URL_PREFIX } = getAppEnvConfig();
  import { useAsyncRouteStore } from '@/store/modules/asyncRoute';
  import I18n from '@/plugins/i18n';

  const userStore = useUserStore();

  import { useRouter, useRoute } from 'vue-router';
  import { GetPicApiReturnType } from '@/api/captcha/type';
  const route = useRoute();
  const router = useRouter();
  const asyncRouteStore = useAsyncRouteStore();
  // const codeImage = ref('');
  // console.log(router.currentRoute, '这是跳转参数');
  const loading = ref(false);
  const loginFrom = reactive<LoginFrom>({
    username: '',
    password: '',
    // code: '',
    captcha: '',
    url: '',
    rememberMe: false,
  });
  const dialog = useDialog();
  // 移除缓存组件名称
  const delKeepAliveCompName = () => {
    if (route.meta.keepAlive) {
      const name = router.currentRoute.value.matched.find((item) => item.name == route.name)
        ?.components?.default.name;
      if (name) {
        asyncRouteStore.keepAliveComponents = asyncRouteStore.keepAliveComponents.filter(
          (item) => item != name
        );
      }
    }
  };
  // 刷新页面
  const reloadPage = () => {
    delKeepAliveCompName();
    router.replace({
      path: '/redirect' + unref(route).fullPath,
      query: router.currentRoute.value?.query,
    });
  };
  /**
   * 登录
   */
  async function loginHandler() {
    if (!loginFrom.captcha)
      return window['$message'].error(I18n.global.t('views.login.checkCaptcha'));
    try {
      loading.value = true;
      console.log(loginFrom);
      const { code, message: msg } = await userStore.login(unref(loginFrom));
      if (code === ResultCodeEnum.SUCCESS) {
        dialog.destroyAll();
        reloadPage();
      } else if (code == 504) {
        window['$message'].info(I18n.global.t('views.login.loginWrong'));
      } else if (code == 503) {
        window['$message'].info(I18n.global.t('views.login.loginExpired'), { duration: 4000 });
      } else {
        window['$message'].info(msg || I18n.global.t('views.login.loginFail'));
      }
    } finally {
      loading.value = false;
    }
  }
  async function captchaPic() {
    if (VITE_GLOB_API_URL_PREFIX) {
      loginFrom.url = VITE_GLOB_API_URL_PREFIX + '/captcha?t=' + Math.random();
    } else {
      loginFrom.url = '/captcha?t=' + Math.random();
    }
  }
  onMounted(() => {
    captchaPic();
  });
</script>
